import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  FormGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Link,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

import { Form, Formik } from "formik";
import { toast, Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import InputField from "../../common/InputField";

import { updateVdsProfile } from "../../services/user/UserServices";
import {
  initialValues as PortfolioInitialValues,
  validate,
} from "../../constants/portfolio";
import { PrimaryButton } from "../../common/Buttons";

import "./portfolio.scss";
import { useTranslation } from "react-i18next";
import PhoneFieldWrapper from "../../common/phoneFieldWrapper/PhoneFieldWrapper";
import { CheckBox } from "@mui/icons-material";
import BranchDocumentNotification from "../../common/BranchDocumentNotification";
// import { CheckBox } from "@mui/icons-material";
const UserDataForm = ({ data, next, handleMfaTokenId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState(PortfolioInitialValues);
  //const [futureCarePermissions, setFutureCarePermissions] = useState(true);
  //const [futureCareTermsOfUse, setFutureCareTermsOfUse] = useState(true);
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(false); // Initialize as disabled
  const [documentChangeNotification, setDocumentChangeNotification] =
    useState(false); // Initialize as disabled
  const [
    documentChangeNotificationMessage,
    setDocumentChangeNotificationMessage,
  ] = useState("");
  const handleSubmit = async (values) => {
    //setFutureCarePermissions(values.futureCarePermissions);
    //(values.futureCareTermsOfUse);
    setIsNextButtonDisabled(false);
    const result = await updateVdsProfile(values);
    if (result?.success) {
      if (result?.payLoad?.otp != null) {
        handleMfaTokenId(result?.payLoad?.mfaTokenId);
        //setFutureCarePermissions(values.futureCarePermissions);

        next();
      } else {
        navigate("/");
      }
    } else {
      toast.error(result?.message);
    }
  };
  useEffect(() => {
    setDocumentChangeNotification(
      !data?.futureCarePermissions || !data?.futureCareTermsOfUse
    );
    if (!data?.futureCarePermissions && !data?.futureCareTermsOfUse) {
      setDocumentChangeNotificationMessage("both-notification");
    } else if (!data?.futureCareTermsOfUse) {
      setDocumentChangeNotificationMessage("terms-of-use-notification");
    } else if (!data?.futureCarePermissions) {
      setDocumentChangeNotificationMessage("privacy-policy-notification");
    }
  }, []);
  useEffect(() => {
    setInitialValues(
      data === null
        ? PortfolioInitialValues
        : {
            ...PortfolioInitialValues,
            ...data,
            phoneNumber: data?.phoneNumber === null ? "+49" : data?.phoneNumber,
            dateOfBirth: data.dateOfBirth.slice(0, 10),
          }
    );
    // if (data && data.futureCarePermissions !== undefined) {
    //   setFutureCarePermissions(data.futureCarePermissions);
    // }
    // if (data && data.futureCareTermsOfUse !== undefined) {
    //   setFutureCareTermsOfUse(data.futureCareTermsOfUse);
    // }
  }, [data]);
  // useEffect(() => {
  //   setIsNextButtonDisabled(!futureCarePermissions || !futureCareTermsOfUse);
  // }, [futureCarePermissions, futureCareTermsOfUse]);

  // const handleFutureCarePermissionsChange = (event) => {
  //   setFutureCarePermissions(event.target.checked);
  // };

  // const handleFutureCareTermsOfUseChange = (event) => {
  //   setFutureCareTermsOfUse(event.target.checked);
  // };

  // const [futureCarePermissions, setfutureCarePermissions] = useState(
  //   initialValues.futureCarePermissions
  // );

  // const handlefutureCarePermissionsChange = (event) => {
  //   setfutureCarePermissions(event.target.checked);
  // };
  const [emailValue, setEmailValue] = useState("");

  const handleEmailChange = (event) => {
    const { value } = event.target;
    setEmailValue(value);
  };

  useEffect(() => {
    setEmailValue(initialValues.email);
  }, [initialValues.email]);

  const isEditable = !document.querySelector(".custom-disable");
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      className="portfolio-page"
    >
      <Grid
        container
        direction="column"
        marginTop="3rem"
        padding="1rem"
        width="30%"
        className="main-div"
      >
        <>
          <Toaster />
          <Typography variant="p" color="color.magentaDark1" fontSize="22px">
            {t("step")} 1 {t("from")} 2
          </Typography>
          <br />
          <Typography variant="h4" fontWeight="bold" color="color.magentaDark1">
            {t("user-data")}
          </Typography>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validate(t)}
            onSubmit={handleSubmit}
            status={{ isValid: true }} // Initialize the status object
          >
            {(formik) => (
              <Form autoComplete="off">
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="John"
                  label={t("input-1")}
                  name="firstName"
                  type="text"
                />
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="Doe"
                  label={t("input-10")}
                  name="lastName"
                  type="text"
                />
                {/* <InputField
                  autocomplete="off"
                  fullWidth
                  variant="standard"
                  placeholder="Doe"
                  label={t("input-3")}
                  name="email"
                  type="email"
                  className="custom-disable"
                  InputLabelProps={{ shrink: true }}
                /> */}
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="Doe"
                  label={t("input-3")}
                  name="email"
                  type="email"
                  className={`custom-disable ${isEditable ? "" : "disabled"}`}
                  InputLabelProps={{ shrink: true }}
                  value={emailValue}
                  onChange={isEditable ? handleEmailChange : () => {}}
                  disabled={!isEditable}
                />

                <InputField
                  autocomplete="off"
                  fullWidth
                  variant="standard"
                  label={t("input-2")}
                  name="dateOfBirth"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                />

                <FormControl variant="standard" margin="dense" fullWidth>
                  <InputLabel id="demo-simple-select-standard-label">
                    {t("input-21")}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    name="gender"
                    onChange={(event) => {
                      formik.setFieldValue("gender", event.target.value);
                    }}
                    label={t("age")}
                    value={formik.values.gender}
                  >
                    <MenuItem value={"male"}>{t("male")}</MenuItem>
                    <MenuItem value={"female"}>{t("female")}</MenuItem>
                    <MenuItem value={"other"}>{t("rm-type-7")}</MenuItem>
                  </Select>
                  <p style={{ margin: 0, fontSize: "12px", color: "red" }}>
                    {formik.errors.gender}
                  </p>
                </FormControl>
                <Grid container spacing={2}>
                  <Grid item lg={7} md={6} xs={12}>
                    <InputField
                      autocomplete="off"
                      fullWidth
                      variant="standard"
                      placeholder={t("input-6")}
                      label={t("input-6")}
                      name="street"
                      type="text"
                    />
                  </Grid>
                  <Grid item lg={5} md={6} xs={12}>
                    <InputField
                      autocomplete="off"
                      fullWidth
                      variant="standard"
                      placeholder="40023"
                      label={t("input-7")}
                      name="houseNumber"
                      type="text"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item lg={7} md={6} xs={12}>
                    <InputField
                      autocomplete="off"
                      fullWidth
                      variant="standard"
                      placeholder="New york"
                      label={t("input-8")}
                      name="city"
                      type="text"
                    />
                  </Grid>
                  <Grid item lg={5} md={6} xs={12}>
                    <InputField
                      autocomplete="off"
                      fullWidth
                      variant="standard"
                      label={t("input-9")}
                      name="postalCode"
                      type="number"
                    />
                  </Grid>
                </Grid>
                {/* <InputField
                  fullWidth
                  variant="standard"
                  placeholder="2842394789"
                  label={t("input-4")}
                  name="phoneNumber"
                  type="string"
                /> */}
                <InputLabel
                  id="demo-simple-select-standard-label"
                  className="phone-number-field"
                >
                  {t("input-24")}
                </InputLabel>
                <PhoneFieldWrapper name="phoneNumber" formik={formik} />
                <Grid className="position-relative new-check">
                  <FormControlLabel
                    control={
                      <Checkbox
                        //type="chekbox"
                        name="futureCarePermissions"
                        // onChange={(event) => {
                        //   formik.setFieldValue(
                        //     "futureCarePermissions",
                        //     event.target.value == "on" ? true : false,
                        //   );
                        // }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        // value={formik.values.futureCarePermissions}
                        checked={formik.values.futureCarePermissions}
                        className={
                          formik.errors.futureCarePermissions &&
                          formik.touched.futureCarePermissions
                            ? "error-checkbox"
                            : ""
                        }
                      />
                    }
                  />
                  <Grid className="ms-3 fs-12 new-check-text">
                    Ich habe die
                    <Link href="/imprint" target="_blank" className="px-2">
                      <u> Nutzungsbedingungen </u>
                    </Link>
                    und
                    <Link
                      href="/privacy-policy"
                      target="_blank"
                      className="px-2"
                    >
                      <u> Datenschutzhinweise </u>
                    </Link>
                    zur Kenntnis genommen.
                  </Grid>
                </Grid>
                {formik.errors.futureCarePermissions &&
                  formik.touched.futureCarePermissions && (
                    <div className="error-message">
                      {formik.errors.futureCarePermissions}
                    </div>
                  )}
                <Grid className="position-relative new-check">
                  <FormControlLabel
                    control={
                      <Checkbox
                        //type="chekbox"
                        name="futureCareTermsOfUse"
                        // onChange={(event) => {
                        //   formik.setFieldValue(
                        //     "futureCareTermsOfUse",
                        //     event.target.checked
                        //     // event.target.value == "on" ? true : false
                        //   );
                        // }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        // value={formik.values.futureCareTermsOfUse}
                        checked={formik.values.futureCareTermsOfUse}
                        className={
                          formik.errors.futureCareTermsOfUse &&
                          formik.touched.futureCareTermsOfUse
                            ? "error-checkbox"
                            : ""
                        }
                      />
                    }
                    className="second-box"
                  />
                  <Grid className="ms-3 fs-12 new-check-text">
                    Die Anwendung „Future Care“ dient dem Nutzer zur
                    übersichtlichen Darstellung seiner familiären Situation
                    sowie der Erfassung seiner Vermögensbilanz nebst ergänzenden
                    Unterlagen für seine eigenen persönlichen Zwecke. Hiermit
                    willige ich ein, dass die Volksbank pur eG,
                    Ludwig-Erhard-Allee 1, 76131 Karlsruhe, die hinterlegten
                    Daten und Dokumente einsehen, verwenden und in ihrem
                    bankeigenen System speichern darf, um diese für
                    Beratungszwecke zu nutzen.
                  </Grid>
                </Grid>
                {formik.errors.futureCareTermsOfUse &&
                  formik.touched.futureCareTermsOfUse && (
                    <div className="error-message">
                      {formik.errors.futureCareTermsOfUse}
                    </div>
                  )}
                <Grid
                  container
                  spacing={2}
                  marginTop="1rem"
                  className="form-buttons"
                >
                  <Grid item lg={6} width="50%">
                    <PrimaryButton
                      width="100%"
                      fullWidth={true}
                      textTransform="capitalize"
                      click={formik.handleSubmit}
                      disabled={isNextButtonDisabled}
                    />
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </>
      </Grid>
      <BranchDocumentNotification
        isOpen={documentChangeNotification}
        message={t(documentChangeNotificationMessage)}
        handleClose={() => {
          setDocumentChangeNotification(false);
        }}
      />
    </Grid>
  );
};

export default UserDataForm;
